import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgRadialLoader = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  stroke: "#353331",
  viewBox: "0 0 44 44",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsxs("linearGradient", {
      id: "a",
      x1: "0%",
      x2: "100%",
      y1: "0%",
      y2: "0%",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0%"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "25%",
        stopColor: "gray"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "60%",
        stopColor: "gray",
        stopOpacity: 0.5
      }), /*#__PURE__*/_jsx("stop", {
        offset: "90%",
        stopColor: "gray",
        stopOpacity: 0.2
      }), /*#__PURE__*/_jsx("stop", {
        offset: "100%",
        stopColor: "gray",
        stopOpacity: 0
      })]
    })
  }), /*#__PURE__*/_jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 4,
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 22,
      cy: 22,
      r: 20,
      strokeOpacity: 0.2
    }), /*#__PURE__*/_jsx("path", {
      stroke: "url(#a)",
      d: "M22 2a20 20 0 1 1 0 40 20 20 0 1 1 0-40",
      children: /*#__PURE__*/_jsx("animateTransform", {
        attributeName: "transform",
        dur: "2s",
        from: "0 22 22",
        repeatCount: "indefinite",
        to: "360 22 22",
        type: "rotate"
      })
    })]
  })]
});
export default SvgRadialLoader;